import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

interface Token {
  symbol: string;
  image: string;
  balance: number;
  min: number;
  max: number;
}

interface Props {
  selectedToken: Token | null;
  onSelect: (token: Token) => void;
  tokenList: Token[];
  isOpen: boolean;
  onToggle: () => void;
}


export const TokenSelector: React.FC<Props> = ({
  selectedToken,
  onSelect,
  tokenList,
  isOpen,
  onToggle,
}) => {
  return (
    <div className="relative inline-block text-left">
      <button
        onClick={onToggle}
        className="flex items-center gap-2 px-2 py-1 rounded border border-transparent hover:border-gray-300 dark:hover:border-gray-600 transition duration-300 ease-in-out"
      >
        {selectedToken ? (
          <>
            <img src={selectedToken.image} alt={selectedToken.symbol} className="w-5 h-5" />
            <span className="text-base font-medium">{selectedToken.symbol}</span>
          </>
        ) : (
          <span className="text-base font-medium text-gray-400">Select Token</span>
        )}
        <ChevronDown size={14} className="text-gray-500 dark:text-gray-400" />
      </button>

      {isOpen && (
        <div className="absolute z-20 mt-1 w-36 dark:bg-[#0A0B0D] bg-white border-[0.5px] border-green-200 rounded-lg shadow-md max-h-60 overflow-y-auto scroll-bar-style">
          {tokenList.map((token) => (
            <button
              key={token.symbol}
              className="flex items-center gap-2 px-3 py-1.5 w-full hover:bg-gray-100 dark:hover:bg-gray-800 text-left"
              onClick={() => {
                onSelect(token);
              }}
            >
              <img src={token.image} alt={token.symbol} className="w-5 h-5" />
              <span className="text-[14px] font-medium">{token.symbol}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

